
import { useState } from 'react';
import { A2AOrchestrationPlan } from '@/utils/a2a/types';
import { getActivePlans } from '@/utils/a2a/orchestration/adaptive';
import { toast } from 'sonner';

export const useTaskOrchestration = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [orchestrationPlans, setOrchestrationPlans] = useState<A2AOrchestrationPlan[]>([]);

  const updateOrchestrationPlans = () => {
    setOrchestrationPlans(getActivePlans());
  };

  return {
    isProcessing,
    orchestrationPlans,
    setIsProcessing,
    setOrchestrationPlans,
    updateOrchestrationPlans
  };
};
